import React from 'react';

const Textarea = ({preguntaId, onChange}) => {

    const handleChange = (e) => {
        onChange(preguntaId, e.target.value); // Llama a la función onChange pasándole el nuevo valor del input
    };

    return (
        <React.Fragment>
            <div>
                <textarea 
                    rows="3" 
                    className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-400 b-1 focus:ring focus:ring-customRed focus:ring-opacity-30 focus:outline-none" placeholder="Respon aqui"
                    onChange={handleChange}
                    required
                ></textarea>
            </div>
        </React.Fragment>
    );
}

export default Textarea;